'use client';

import dynamic from 'next/dynamic';
import { FeatureFlag } from '../common/feature-flag';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { GtmInitiator } from '@wwe-portal/web/libs/gtm/gtm-initiator';

const AutoClaimRewards = dynamic(
  () =>
    import('../../components/limited-time-events/auto-claim-rewards').then(
      (module) => ({
        default: module.AutoClaimRewards,
      })
    ),
  { ssr: false }
);

const InterstitialDialog = dynamic(
  () =>
    import('../../components/interstitial/interstitial-dialog').then(
      (module) => ({
        default: module.InterstitialDialog,
      })
    ),
  { ssr: false }
);

const StampCard = dynamic(
  () =>
    import('../../components/stampcard').then((module) => ({
      default: module.StampCard,
    })),
  { ssr: false }
);

const FeatureFlagDebug = dynamic(
  () =>
    import('../../components/common/feature-flag/debug').then((module) => ({
      default: module.FeatureFlagDebug,
    })),
  { ssr: false }
);

const DatadogInitiator = dynamic(
  () =>
    import('../../components/common/initiator/datadog').then((module) => ({
      default: module.DatadogInitiator,
    })),
  { ssr: false }
);

const Onboarding = dynamic(
  () =>
    import('../../components/onboarding').then((module) => ({
      default: module.Onboarding,
    })),
  { ssr: false }
);

const GlobalAnalytics = dynamic(() =>
  import('./analytics/global-analytics').then((mod) => mod.GlobalAnalytics)
);

const GameLoginListener = dynamic(
  () =>
    import('../../components/auth/game-login-listener').then((module) => ({
      default: module.GameLoginListener,
    })),
  { ssr: false }
);

const XsollaInitiator = dynamic(
  () =>
    import('../../components/external/xsolla-initiator').then((module) => ({
      default: module.XsollaInitiator,
    })),
  { ssr: false }
);

const GlobalScrollListener = dynamic(
  () =>
    import('../../components/layout/listener/global-scroll-listener').then(
      (mod) => mod.GlobalScrollListener
    ),
  { ssr: false }
);

const HelpshiftInitiator = dynamic(
  () =>
    import('../../libs/helpshift/initiator').then(
      (mod) => mod.HelpshiftInitiator
    ),
  { ssr: false }
);

const AppConnectListener = dynamic(
  () =>
    import('../../components/layout/listener/app-open-listener').then(
      (mod) => mod.AppConnectListener
    ),
  { ssr: false }
);

const ClarityInitiator = dynamic(
  () =>
    import('../../libs/clarity/clarity-initiator').then(
      (mod) => mod.ClarityInitiator
    ),
  { ssr: false }
);

const WindowSizeListener = dynamic(
  () =>
    import('@wwe-portal/ui/components/window-size-listener').then(
      (mod) => mod.WindowSizeListener
    ),
  { ssr: false }
);

export const LazySlot = () => {
  const { isHydrated } = useResponsive();
  if (!isHydrated) return;
  return (
    <>
      <AutoClaimRewards />
      <InterstitialDialog />
      <StampCard />
      <FeatureFlag flag="overhaul.tutorial">
        <Onboarding />
      </FeatureFlag>

      <FeatureFlagDebug />

      <XsollaInitiator />
      <HelpshiftInitiator />

      <GlobalAnalytics />
      <DatadogInitiator />
      <ClarityInitiator />
      <GtmInitiator />

      <WindowSizeListener />
      <GameLoginListener />

      <GlobalScrollListener />
      <AppConnectListener />
    </>
  );
};
